import { ButtonProps, Text, Button, TextProps, Icon } from "@ttc3k/trekker";
import { Skeleton, SkeletonProps } from "shared/components";
import { JsxStyleProps } from "styled-system/types";
import type { ReactNode } from "react";

type JsxStylePropsWithClassName = JsxStyleProps & { className?: string };
export interface EmptyStateProps
  extends SkeletonProps,
    JsxStylePropsWithClassName {
  text?: string | ReactNode;
  textProps?: TextProps;
  complexText?: TextProps;
  ctaButtonProps?: ButtonProps;
  part?: string;
  children?: ReactNode;
  Icon?: React.ForwardRefExoticComponent<
    Omit<React.SVGProps<SVGSVGElement>, "ref"> &
      React.RefAttributes<SVGSVGElement>
  >;
}

export const EmptyState = ({
  text,
  textProps,
  complexText,
  ctaButtonProps,
  Icon: IconElement,
  children,
  ...props
}: EmptyStateProps) => {
  return (
    <Skeleton {...props}>
      {IconElement && <Icon Element={IconElement} size={"xl"} />}
      {text && !complexText && (
        <Text visual={"bodyMedium"} textAlign={"center"} {...textProps}>
          {text}
        </Text>
      )}
      {complexText && <Text {...complexText} />}
      {ctaButtonProps && (
        <Button
          size={"lg"}
          visual={
            !props.visual || ["accent.cream"].includes(props.visual)
              ? "primary"
              : props.visual
          }
          // Always use light mode for accent.cream and primary, otherwise
          // use dark mode
          mode={
            ["accent.cream", "primary"].includes(props.visual || "primary")
              ? "light"
              : "dark"
          }
          {...ctaButtonProps}
        />
      )}
      {children}
    </Skeleton>
  );
};
